<template>
  <div class="strata-report-component">
    <vue-form ref="form" :options="{ permalink: 'generateStrataReport' }">
      <div class="card-header" slot="title">Generate Report</div>
    </vue-form>
  </div>
</template>

<script>
import VueForm from '@/components/Form'

export default {
  name: 'StrataReport',
  components: {
    VueForm
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/StrataReport.vue